
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'ShowImages',
  props: {
    comment: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    function countImageFiles(files: any[]): number {
      if (!files) {
        return 0;
      }

      const allowedExtensions = ['jpg', 'jpeg', 'png'];
      let count = 0;

      files.forEach(file => {
        const type = file.contentType.split('/')[1];

        if (allowedExtensions.includes(type)) {
          count++;
        }
      });

      return count;
    }

    const onClickImg = (url: string) => {
      window.open(url);
    };

    return {
      countImageFiles,
      onClickImg,
    };
  },
});
